// @ts-check
import React from 'react';

import CpanelIcon from '@liquidweb-dev/undercurrent/icons/platform/CPanel';
import InterworxIcon from '@liquidweb-dev/undercurrent/icons/platform/Interworx';

/**
 * @param {import('@liquidweb-dev/undercurrent/types/svgTypes').FixedColorSvgProps & {
 *   controlPanel: string
 * }} props
 * */
const ControlPanelIcon = ({ controlPanel, ...rest }) => {
	const controlPanelLowerCase = controlPanel.toLowerCase();

	if (controlPanelLowerCase.includes('cpanel')) {
		return <CpanelIcon {...rest} />;
	}

	if (controlPanelLowerCase.includes('interworx')) {
		return <InterworxIcon {...rest} />;
	}

	return null;
};

export default ControlPanelIcon;
